import { createContext } from "react";

export default createContext((options) => {
  return new Promise((resolve, reject) => {});
});
